import { BestTimeToCallIcon } from '@forwardflow/assets/svg/BestTimeToCallIcon'
import {
   LineChart,
   Line,
   XAxis,
   Tooltip,
   ResponsiveContainer,
   ReferenceArea,
} from 'recharts'

const LINE_COLORS = {
   monday: '#9061DA',
   tuesday: '#FF6B6B',
   wednesday: '#4ECDC4',
   thursday: '#FFD93D',
   friday: '#95E1D3',
   saturday: '#FF8B94',
   sunday: '#6C5CE7',
}

const createLineConfig = (dataKey: string) => ({
   type: 'monotone' as const,
   dataKey,
   stroke: LINE_COLORS[dataKey as keyof typeof LINE_COLORS],
   strokeWidth: 2,
   activeDot: { r: 5 },
   dot: { r: 0 },
   opacity: 0.7,
})

const staticData = [
   {
      hour: '8 AM',
      hourIndex: 0,
      monday: 68,
      tuesday: 74,
      wednesday: 70,
      thursday: 72,
      friday: 69,
      saturday: 75,
   },
   {
      hour: '9 AM',
      hourIndex: 1,
      monday: 92,
      tuesday: 88,
      wednesday: 95,
      thursday: 90,
      friday: 93,
      saturday: 89,
   },
   {
      hour: '10 AM',
      hourIndex: 2,
      monday: 83,
      tuesday: 80,
      wednesday: 85,
      thursday: 81,
      friday: 79,
      saturday: 84,
   },
   {
      hour: '11 AM',
      hourIndex: 3,
      monday: 45,
      tuesday: 39,
      wednesday: 48,
      thursday: 43,
      friday: 41,
      saturday: 46,
   },
   {
      hour: '12 PM',
      hourIndex: 4,
      monday: 22,
      tuesday: 19,
      wednesday: 25,
      thursday: 21,
      friday: 20,
      saturday: 23,
   },
   {
      hour: '1 PM',
      hourIndex: 5,
      monday: 13,
      tuesday: 11,
      wednesday: 15,
      thursday: 12,
      friday: 10,
      saturday: 14,
   },
   {
      hour: '2 PM',
      hourIndex: 6,
      monday: 12,
      tuesday: 10,
      wednesday: 14,
      thursday: 13,
      friday: 11,
      saturday: 13,
   },
   {
      hour: '3 PM',
      hourIndex: 7,
      monday: 21,
      tuesday: 18,
      wednesday: 23,
      thursday: 20,
      friday: 19,
      saturday: 22,
   },
   {
      hour: '4 PM',
      hourIndex: 8,
      monday: 41,
      tuesday: 38,
      wednesday: 44,
      thursday: 40,
      friday: 39,
      saturday: 43,
   },
   {
      hour: '5 PM',
      hourIndex: 9,
      monday: 82,
      tuesday: 85,
      wednesday: 80,
      thursday: 84,
      friday: 81,
      saturday: 86,
   },
   {
      hour: '6 PM',
      hourIndex: 10,
      monday: 91,
      tuesday: 94,
      wednesday: 89,
      thursday: 93,
      friday: 90,
      saturday: 95,
   },
   {
      hour: '7 PM',
      hourIndex: 11,
      monday: 87,
      tuesday: 83,
      wednesday: 90,
      thursday: 88,
      friday: 85,
      saturday: 89,
   },
   {
      hour: '8 PM',
      hourIndex: 12,
      monday: 62,
      tuesday: 59,
      wednesday: 65,
      thursday: 61,
      friday: 60,
      saturday: 63,
   },
]

const CustomTooltip = ({ active, payload, label }: any) => {
   if (!active || !payload || !payload.length) return null
   const activeDay = payload.reduce((max: any, current: any) =>
      current.value > max.value ? current : max
   )
   return (
      <div className="p-2 bg-gray-800 border border-gray-600 rounded custom-tooltip">
         <p className="text-sm text-white">{`${label}`}</p>
         <p
            className="text-sm font-medium capitalize"
            style={{ color: activeDay.color }}
         >
            {`${activeDay.name}: ${activeDay.value}%`}
         </p>
      </div>
   )
}

export const BestTimeToCallPanel = () => (
   <div className="h-full p-0 overflow-hidden shadow-lg bg-white/5 rounded-2xl">
      <div className="flex items-center gap-4 px-6 py-4 mb-2">
         <BestTimeToCallIcon />

         <span className="text-lg font-semibold">Best time to Call</span>
      </div>
      <div className="p-6">
         <div className="pl-3 mb-2 text-white/70">
            Best time to call your leads
         </div>
         <div className="pl-3 mb-6 text-lg font-semibold">
            8:00 - 10:00 am
            <span className="font-normal text-white/70"> and </span>
            5:00 - 8:00 pm
         </div>
         <ResponsiveContainer width="100%" height={180}>
            <LineChart
               data={staticData}
               margin={{ top: 5, right: 15, left: 15, bottom: 0 }}
            >
               <XAxis
                  dataKey="hour"
                  strokeWidth={0}
                  opacity={0.5}
                  interval={1}
                  color="#fff"
                  tick={{ fill: '#fff', fontSize: 12 }}
                  tickLine={false}
                  axisLine={false}
               />
               <Tooltip
                  content={<CustomTooltip />}
                  cursor={{
                     stroke: '#ffffff',
                     strokeWidth: 1,
                     strokeOpacity: 0.5,
                  }}
               />
               <ReferenceArea
                  x1="8 AM"
                  x2="10 AM"
                  fill="#ffffff"
                  fillOpacity={0.05}
               />
               <ReferenceArea
                  x1="5 PM"
                  x2="8 PM"
                  fill="#ffffff"
                  fillOpacity={0.05}
               />
               {Object.keys(LINE_COLORS).map((day) => (
                  <Line
                     key={day}
                     {...createLineConfig(day)}
                     isAnimationActive={false}
                  />
               ))}
            </LineChart>
         </ResponsiveContainer>
      </div>
   </div>
)
